export default __webpack_public_path__ + "static/coinbundle-3cca4d55c8ad0dbc54d669adc88ffaeb.png";